import { render, staticRenderFns } from "./projectSet.vue?vue&type=template&id=04fff299&scoped=true&"
import script from "./projectSet.vue?vue&type=script&lang=js&"
export * from "./projectSet.vue?vue&type=script&lang=js&"
import style0 from "./projectSet.vue?vue&type=style&index=0&id=04fff299&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fff299",
  null
  
)

export default component.exports